
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SuluMedia } from '@/logic/cms/sulu';

@Component
export default class Hero extends Vue {
  @Prop(String)
  title!: string;

  @Prop(String)
  subtitle!: string;

  @Prop({ type: [String, Object] })
  image!: string | SuluMedia;

  @Prop(String)
  pageName!: string;

  @Prop({ type: Boolean, default: true })
  mask!: boolean;

  @Prop({ type: Boolean, default: false })
  gradient!: boolean;

  $helpers: any;

  get hasImageMask(): boolean {
    if (!this.mask) {
      return false;
    }
    const pageWithoutMask = [
      'dashboard',
      'e-learning',
      'eat-this',
      'multinational',
    ];
    return !pageWithoutMask.includes(this.pageName);
  }

  get imageUrl(): string | object {
    if (!this.image) {
      return '';
    }

    if (typeof this.image === 'string') {
      return this.image;
    }

    return this.$helpers.getApiImageThumbnail(this.image);
  }

  get imagePosition(): string {
    if (!this.image) {
      return '';
    }

    return this.$helpers.getApiImageFocuspoint(this.image);
  }

  get imageStyle(): string {
    const imagePosition = `background-position: ${this.imagePosition};`;

    if (this.gradient) {
      return `${imagePosition} background-image: linear-gradient(108.19deg, #003764 12.06%, rgba(0, 55, 100, 0.36) 94.52%),url('${this.imageUrl}')`;
    }

    return `${imagePosition} background-image: url('${this.imageUrl}')`;
  }
}
